import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import store from 'store';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Box from 'ui-box';
import { Button, Divider } from 'antd';
import HeaderBack from '../../../../components/mobile/HeaderBack';
import BoxUserCallMethod from '../../../../components/mobile/user-account/BoxUserCallMethod';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import PhoneInputField from '../../../../components/mobile/form-helpers/PhoneInputField';
import { putPatienAnonymousAPICall } from '../../../../api/patient';
import { LOCAL_STORAGE_AUTH_KEY } from '../../../../config/constants';
import { errorNotification } from '../../../../utils/notification-helpers';
import { postAppointmentAll } from '../../../../utils/helpers';

const styles = {
  divider: {
    fontSize: 14,
    fontWeight: 28,
    color: '#999999',
    margin: 0
  },
  rowButton: {
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
}

function MobileSelectContactGuestScreen() {
  const { t } = useTranslation(['sign-up', 'common']);
  const history = useHistory();

  const FormSchema = useMemo(
    () =>
      Yup.object().shape({
        preferred_comm_platform: Yup.string().required(t('common:form.error.required')),
        mobile: Yup.string().required(t('common:form.error.required')),
      }),
    [t]
  );

  const initialValues = {
    preferred_comm_platform: 'direct',
    mobile: ''
  };

  const onBack = () => {
    history.push('/speak-doctor')
  }

  return (
    <>
      <HeaderBack
        onBack={onBack}
        text={t('sign-up:returnToPreviousPage')}
        title={t('sign-up:howCanWeReachYou')}
        subtitle={t('sign-up:guest.contactMethodSubtitle')}
      />
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={FormSchema}
        onSubmit={async (values) => {
          const dataForm = { ...values };
          const { responseOk } = await putPatienAnonymousAPICall(dataForm);
          const profileGuest = store.get(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE_GUEST);
          profileGuest.preferred_comm_platform = dataForm.preferred_comm_platform;
          profileGuest.mobile = dataForm.mobile;
          if (responseOk) {
            store.set(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE_SIGNUP, profileGuest)
            store.set(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE_GUEST, profileGuest)
            const { checkOk } = await postAppointmentAll(values.mobile)
            if (checkOk) {
              history.push('/sign-up/guest/remainder');
            }
          } else {
            errorNotification(t('common:form.error.submit'));
          }
        }}
      >
        {({ isSubmitting, isValid, values }) => {
          return (
            <Form>
              <fieldset disabled={isSubmitting}>
                <Box marginTop={10} marginBottom={30}>
                  <PhoneInputField
                    name="mobile"
                    placeholder={t('sign-up:mobileNumber')}
                  />
                </Box>
                <Box marginBottom={25}>
                  <Divider plain><p style={styles.divider}>{t('sign-up:guest.selectMethod')}</p></Divider>
                </Box>
                <BoxUserCallMethod fieldName="preferred_comm_platform" selectedMethod={values.preferred_comm_platform} />
                <Box marginTop={30} paddingTop={15}>
                  <Button
                    disabled={isSubmitting || !isValid}
                    loading={isSubmitting}
                    htmlType="submit"
                    type="primary"
                    size="large"
                    block
                  >
                    <p style={styles.rowButton}>
                      {
                        isSubmitting
                        ? <LoadingSpinner position="full" transparent={false} />
                        : (
                            <>
                              {t('common:button.submit')}
                            </>
                          )
                      }
                    </p>
                  </Button>
                </Box>
              </fieldset>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}

export default MobileSelectContactGuestScreen;
